import axios from 'axios'

const SERVER_URL = process.env.VUE_APP_SERVER_URL ? process.env.VUE_APP_SERVER_URL : 'https://croinc.bearle.ru';
const API_URL = `${SERVER_URL}/api/v1`;

const CID = localStorage.hasOwnProperty('CID') ? localStorage.getItem('CID') : ''

const API_KEY = process.env.VUE_APP_COMPANY_ID ? process.env.VUE_APP_COMPANY_ID : CID;

const http = axios.create({
  baseURL: `${API_URL}/${API_KEY}`,
});

export const setCompanyId = (id) => {
  http.defaults.baseURL = `${API_URL}/${id}`;
}

export const getSalons = async () =>
  http.get(`/salons/`).then(res => res.data.results);


export const getSalonServices = async (salonId, gender) => (
  http.get(`/salons/${salonId}/services/?gender=${gender}`).then(res => res.data.services)
);

export const getSalonPopularServices = async (salonId) => (
  http.get(`/salons/${salonId}/popular`).then(res => res.data)
);

export const getSalonMasters = async (salonId) => (
  http.get(`/salons/${salonId}/masters/`).then(res => res.data.masters)
);

export const getSalonServiceMasters = async (salonId, serviceId, serviceLevelId, gender, date) => {
  if (serviceLevelId) {
    return http.get(`/salons/${salonId}/masters/?service_id=${serviceId}&service_level_id=${serviceLevelId}&gender=${gender}&date=${date}`)
      .then(res => res.data.masters)
  } else {
    return http.get(`/salons/${salonId}/masters/?service_id=${serviceId}&gender=${gender}&date=${date}`)
      .then(res => res.data.masters)
  }
}

export const getMasterAvailableTime = async (masterId, date, serviceId, serviceLevelId = null, options = null) => (
  http.get(`/master/${masterId}/available_time/`, {
    params: {
      service_id: serviceId,
      service_level_id: serviceLevelId,
      date,
      options
    }
  }).then(res => res.data.intervals)
);

export const getMasterWorkingTime = async (masterId) => (
  http.get(`/master/${masterId}/working_time/`, {
    params: {
    }
  }).then(res => res.data)
);

// @returns true if form successful
export const createEvent = async (data) => {
    return  http.post(`/events/`, data);
};

export const getCompanySettings = async () => (
  http.get('/settings/').then(res => res.data)
);
